module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PhoneInput":{"phone":"Telefon"}},"en":{"PhoneInput":{"phone":"Phone number"}}}')
  delete Component.options._Ctor
}
